export enum Breakpoint {
    xs = 'xs',
    sm = 'sm',
    md = 'md',
    lg = 'lg',
    xl = 'xl',
    xxl = 'xxl',
}

export interface BreakpointsStyles {
    /* eslint-disable @typescript-eslint/no-explicit-any */
    xs?: any;
    sm?: any;
    md?: any;
    lg?: any;
    xl?: any;
    xxl?: any;
    /* eslint-enable @typescript-eslint/no-explicit-any */
}
